<template>

    <div class="add_contacts_choices_container">

        <button @click="$emit('choiceClicked', 'form')" class="button is-info is-outlined">Ajouter des {{ contactLabel }}s</button>
        <button @click="$emit('choiceClicked', 'csv')" class="button is-info is-outlined">Importer un fichier CSV</button>

    </div>

</template>


<script>

export default {
    name: 'AddContactsChoice',
    props: {
        contactLabel: {
            type: String,
            default: 'contact'
        }
    },
    methods: {}
}
</script>

<style lang="scss">
.add_contacts_choices_container{
    display: flex;
    height: 200px;
    justify-content: center;
    align-items: center;
    .button{
        margin: 12px;
        font-size: 1.2rem;
    }
}
</style>